module.exports = __webpack_public_path__ + "static/media/DubaiW23-Bold.8807d3b0.eot";